import { render, staticRenderFns } from "./ServiceYuyue.vue?vue&type=template&id=fe2e611c&scoped=true"
import script from "./ServiceYuyue.vue?vue&type=script&lang=js"
export * from "./ServiceYuyue.vue?vue&type=script&lang=js"
import style0 from "./ServiceYuyue.vue?vue&type=style&index=0&id=fe2e611c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2e611c",
  null
  
)

export default component.exports